import React from 'react';

export default function useSsoError() {
  const [error, setError] = React.useState<{message: string, email?: string} | undefined>(undefined);

  React.useEffect(() => {
    function listener() {
      if (window.location.hash !== '') {
        const ssoErrorMessage = window.location.hash.match(/sso_error=([^&]+)/)?.[1];
        const ssoErrorEmail = window.location.hash.match(/sso_error_email=([^&]+)/)?.[1];
        const ssoError = ssoErrorMessage ? { message: decodeURIComponent(ssoErrorMessage), email: ssoErrorEmail && decodeURIComponent(ssoErrorEmail) } : undefined;
        setError(ssoError);
        if (ssoError) {
          window.location.hash = '';
        }
      }
    }
    window.addEventListener('hashchange', listener);
    listener();
    return () => {
      window.removeEventListener('hashchange', listener);
    };
  }, []);
  return error;
}
